'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.NarrowNews = void 0;
var $ = require("jquery");
var NarrowNews = /** @class */ (function () {
    function NarrowNews(selectedCategory, selectedFacility) {
        if (selectedCategory === void 0) { selectedCategory = 'all'; }
        if (selectedFacility === void 0) { selectedFacility = 'all'; }
        this.selectedCategory = selectedCategory;
        this.selectedFacility = selectedFacility;
        var self = this;
        if ($('#paramThisIsNewsArchivePage').length > 0) {
            // @ts-ignore
            var params = (new URL(document.location)).searchParams;
            var category = params.get('category');
            var facility = params.get('facility');
            if (!category) {
                category = 'all';
            }
            if (!facility) {
                facility = 'all';
            }
            this.selectedCategory = category;
            this.selectedFacility = facility;
            this.selectButton(category, facility);
            self.narrowNews();
        }
        $('.trigNarrowNews').click(function () {
            self.setValues($(this));
            self.narrowNews();
        });
        $('.trigNewsPagenation').click(function (e) {
            e.preventDefault();
            var href = $(this).attr('href');
            href += '?category=' + self.selectedCategory;
            href += '&facility=' + self.selectedFacility;
            location.href = href;
            return false;
        });
    }
    NarrowNews.prototype.narrowNews = function () {
        var category = this.selectedCategory;
        var facility = this.selectedFacility;
        var elms = $('.bulletNarrowNews');
        if (category === 'all' && facility === 'all') {
            elms.show();
            return false;
        }
        elms.hide();
        for (var i = 0; i < elms.length; i++) {
            var elm = elms.eq(i);
            if (category === 'all') {
                if (elm.attr('data-facility') === facility) {
                    elm.show();
                }
            }
            else if (facility === 'all') {
                if (elm.attr('data-category') === category) {
                    elm.show();
                }
            }
            else {
                if (elm.attr('data-facility') === facility && elm.attr('data-category') === category) {
                    elm.show();
                }
            }
        }
    };
    NarrowNews.prototype.setValues = function (elm) {
        var narrow = elm.data('narrow');
        var category = this.selectedCategory;
        var facility = this.selectedFacility;
        if (narrow == 'category') {
            category = elm.data('category');
            this.selectedCategory = category;
        }
        else if (narrow == 'facility') {
            facility = elm.data('facility');
            this.selectedFacility = facility;
        }
        this.selectButton(category, facility);
    };
    NarrowNews.prototype.selectButton = function (category, facility) {
        if (category === void 0) { category = 'all'; }
        if (facility === void 0) { facility = 'all'; }
        $('.trigNarrowNews').attr('data-selected', 0);
        $('.trigNarrowNews[data-category="' + category + '"]').attr('data-selected', 1);
        $('.trigNarrowNews[data-facility="' + facility + '"]').attr('data-selected', 1);
    };
    return NarrowNews;
}());
exports.NarrowNews = NarrowNews;
exports.default = NarrowNews;
